export default __webpack_public_path__ + "static/media/BlueBg.cc2d9553.svg";